<template>
  <div class="broadcast mb-3">
    <div v-if="pageInfo">
      <template v-if="!isEdit">
        <div>
          <v-layout wrap>
            <v-flex xs12 sm8 class="d-flex align-center">
              <div class="primary--text mt-0">{{ pageInfo.name }}</div></v-flex
            >
            <v-flex xs12 sm4 class="text-xs-right">
              <v-btn fab outline small color="primary" @click="isEdit = true">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn fab outline small color="primary" @click="handleDeletePage">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </div>
        <div class="mb-2">
          เพจ: <span class="primary--text">{{ pageInfo.page_id }}</span>
        </div>
        <div>
          หมวดหมู่สินค้า: <span class="primary--text">{{ pageInfo.category_name }}</span>
        </div>
      </template>
      <template v-else>
        <page-manage
          v-model="pageInfo"
          :type="'edit'"
          @onSuccess="handleUpdateSuccess"
          @close="isEdit = false"
        />
      </template>
    </div>
  </div>
</template>

<script>
import tcpApi from '@/api/tcp'
import PageManage from './PageManage'
import { mapGetters } from 'vuex'

export default {
  components: {
    PageManage
  },
  props: ['item'],
  data() {
    return {
      pageInfo: null,
      isEdit: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    item: {
      handler() {
        this.pageInfo = this.item
      },
      deep: true
    }
  },
  mounted() {
    if (this.item) {
      this.pageInfo = this.item
    }
  },
  methods: {
    async handleUpdateSuccess() {
      this.isEdit = false
      await this.$swal.fire({
        type: 'success',
        text: 'สำเร็จ'
      })
      this.$emit('onUpdateSuccess')
    },
    async handleDeletePage() {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          title: vm.$t('Do you want to delete {name}?', {
            name: vm.pageInfo.name
          }),
          type: 'warning',
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true,
          showCancelButton: true
        })
        if (result.value) {
          const response = await vm.deletePage()

          if (response && response.status === 200) {
            vm.$swal.fire({
              type: 'success',
              text: 'สำเร็จ'
            })
            vm.$emit('onUpdateSuccess')
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deletePage() {
      const vm = this
      try {
        const response = await tcpApi.deleteShopPage({
          page_id: vm.pageInfo.page_id,
          master_page_id: vm.selectedBot.pageid
        })

        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/billing/PageManagement/PageItem.vue